import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import PropTypes from "prop-types"
import React from "react"

class RefundBalanceApplicationSettleButton extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      buttonText: this.props.buttonText,
    }
    this.submit = this.submit.bind(this)
  }

  submit() {
    this.setState({ saving: true, buttonText: "Saving..." })
    const params = {
      payment_method: "balance_application",
      amount: this.props.rawAmount,
      payment_method_unique: this.props.paymentMethodUnique,
      receiving_scheduled_payment_id: this.props.receivingScheduledPaymentId,
      credit_scheduled_payment_id: this.props.creditScheduledPaymentId,
    }

    $.ajax({
      url: this.props.postUrl,
      type: "POST",
      data: JSON.stringify(params),
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        location.reload()
      },
      error: (data) => {
        this.setState({ saving: false, buttonText: this.props.buttonText })
      },
    })
  }

  render() {
    return (
      <div>
        <LegacyButton type="secondary" className="btn-sm" onClick={this.submit}>
          {this.state.buttonText}
        </LegacyButton>
      </div>
    )
  }
}

RefundBalanceApplicationSettleButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  rawAmount: PropTypes.number.isRequired,
  paymentMethodUnique: PropTypes.string.isRequired,
  receivingScheduledPaymentId: PropTypes.string.isRequired,
  creditScheduledPaymentId: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
}

export default RefundBalanceApplicationSettleButton
